import {literalUnion, transform} from '@raison/io-ts-tools';
import {Type, number, record, string} from 'io-ts';

export type SemVer = {
    major: number;
    minor: number;
    patch: number;
};

export namespace SemVer {
    export const regex = /^v(?<major>\d{1,3})\.(?<minor>\d{1,3})\.(?<patch>\d{1,3})/; // no $ at the end to allow slightly incorrect format for testing purposes

    const levels = ['major', 'minor', 'patch'] as const;

    const codec = record(
        literalUnion(...levels),
        transform(string, number, parseInt),
        'Version'
    ) satisfies Type<SemVer>;

    export const fromString = transform(string, codec, string => string.match(regex)?.groups);
    export const format = (semver: SemVer) => `v${semver.major}.${semver.minor}.${semver.patch}`;

    export function diff(older: SemVer, newer: SemVer) {
        for (const level of levels) {
            if (newer[level] > older[level]) return {level, action: 'release' as const};
            if (newer[level] < older[level]) return {level, action: 'rollback' as const};
        }
        return null;
    }
}
